import { set } from 'lodash'

const configurations = {}

;(function loadConfigurationSettings () {
  const requireModule = require.context('.', false, /^.*\.locale\.json$/)
  requireModule.keys().forEach((fileName) => {
    const dotCount = (fileName.match(/\./g) || []).length
    if (dotCount !== 4) {
      throw new Error(`Unable to load locale with invalid file name format "${fileName}", Aborting...`)
    }
    const nameSplitInNamespaceAndLocale = fileName.replace(/^(\.\/)|\.locale\.json$/g, '').split('.')
    set(configurations, [nameSplitInNamespaceAndLocale[1], nameSplitInNamespaceAndLocale[0]], requireModule(fileName))
  })
})()

export default configurations
